import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AuthService } from '../../services/security/auth.service';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CodigoAsesorService } from '../../services/codigo-asesor/codigo-asesor.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CertificadosService } from '../../services/certificados/certificados.service';

@Component({
  selector: 'app-certificado-retencion',
  templateUrl: './certificado-retencion.component.html',
  styleUrls: ['./certificado-retencion.component.css'],
})
export class CertificadoRetencionComponent implements AfterViewInit, OnInit {
  @ViewChild('dialogDescargaExitosa') dialogDescargaExitosa!: TemplateRef<any>;
  frmCertificadoRetencion!: FormGroup;

  tiposCertificado = [
    { id: 'RF', nombre: 'ReteFuente' },
    { id: 'RI', nombre: 'ReteICA' },
    { id: 'RV', nombre: 'ReteIVA' },
  ];

  anios: number[] = [];

  periodos: { value: number; label: string }[] = [];

  logInfo: any;
  cedula_Asesor: string = '';
  ciudad_Asesor: string = '';
  generalMessage = '';
  haveDataToShow = false;
  haveResponde = false;
  nombre_Asesor: string = '';
  trackData: any;

  constructor(
    private authService: AuthService,
    private mainCmp: MaincontainerComponent,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private codigoAsesorService: CodigoAsesorService,
    private certificadosService: CertificadosService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    const userCC = this.logInfo?.document;
    this.cedula_Asesor = userCC.split('.')[1].trim();

    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
    this.nombre_Asesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

    this.trackData = {
      module: 'Mis certificados',
      category: 'N/A',
      submodule: 'Certificados de retenciones',
      functionality: 'Generar certificado de retención',
      cedulaAsesor: this.cedula_Asesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombre_Asesor,
      identificadorInteraccion: 'REF_CONSULTA_REF_CONSULTAR'
    };

    this.frmCertificadoRetencion = this.fb.group({
      tipo_certificado: ['', Validators.required],
      anio: ['', Validators.required],
      periodo: ['', Validators.required],
    });

    this.codigoAsesorService.obtenerDataAsesor(this.cedula_Asesor).subscribe({
      next: (data) => {
        this.ciudad_Asesor = data.Ciudad;
        console.log('Ciudad del asesor:', this.ciudad_Asesor);
      },
      error: (err) => {
        alert('Error al obtener el código del asesor.');
      },
    });

    this.frmCertificadoRetencion
      .get('tipo_certificado')
      ?.valueChanges.subscribe((tipo) => {

        this.recalcularAnios();

        this.frmCertificadoRetencion.patchValue({ anio: '', periodo: '' });

        this.recalcularPeriodos();

        const periodoCtrl = this.frmCertificadoRetencion.get('periodo');

        if (tipo === 'RI' || tipo === 'RV') {
          periodoCtrl?.setValidators([Validators.required]);
        } else {
          periodoCtrl?.clearValidators();
          periodoCtrl?.setValue('');
        }

        periodoCtrl?.updateValueAndValidity();
      });

    this.frmCertificadoRetencion
      .get('anio')
      ?.valueChanges.subscribe(() => this.recalcularPeriodos());
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle('certificados de retenciones');
    });
  }

  cargarAnios(tipo: string) {
    const actual = new Date().getFullYear();

    if (tipo === 'RF') {
      this.anios = [actual - 1];
    } else if (tipo === 'RV' || tipo === 'RI') {
      this.anios = [actual - 1, actual];
    }
  }

  actualizarPeriodos(tipo: string, anio: number) {
    this.periodos = [];
    this.frmCertificadoRetencion.patchValue({ periodo: '' });

    if (!tipo || !anio) return;

    anio = Number(anio);

    const hoy = new Date();
    const anioActual = hoy.getFullYear();
    const mesActual = hoy.getMonth() + 1;
    const bimestreActual = Math.ceil(mesActual / 2);

    const obtenerRango = (actual: number, max: number) => {
      if (anio === anioActual) {
        return { inicio: 1, fin: actual };
      } else if (anio === anioActual - 1) {
        return { inicio: actual, fin: max };
      }
      return { inicio: 1, fin: max };
    };

    if (tipo === 'RV') {
      const { inicio, fin } = obtenerRango(bimestreActual, 6);

      for (let i = inicio; i <= fin; i++) {
        this.periodos.push({ value: i, label: `Bimestre ${i}` });
      }

      return;
    }

    if (tipo === 'RI') {
      const ciudad = this.ciudad_Asesor;

      const CIUDADES_ANUALES = [
        'APARTADÓ',
        'ARMENIA',
        'BARRANQUILLA',
        'BUCARAMANGA',
        'BUENAVENTURA',
        'BUGA',
        'CARTAGENA',
        'CARTAGO',
        'CÚCUTA',
        'IBAGUÉ',
        'MANIZALES',
        'MEDELLÍN',
        'MONTERÍA',
        'NEIVA',
        'PALMIRA',
        'PASTO',
        'POPAYÁN',
        'RIOHACHA',
        'RIONEGRO',
        'SABANETA',
        'SANTA MARTA',
        'TULUÁ',
        'VILLAVICENCIO',
      ];

      const CIUDADES_BIMESTRALES = ['BOGOTÁ', 'CALI', 'PEREIRA'];

      const esValledupar = ciudad === 'VALLEDUPAR';
      const esAnual = CIUDADES_ANUALES.includes(ciudad);
      const esBimestral = CIUDADES_BIMESTRALES.includes(ciudad);

      if (esValledupar) {
        const meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ];

        const { inicio, fin } = obtenerRango(mesActual, 12);

        for (let i = inicio; i <= fin; i++) {
          this.periodos.push({
            value: i,
            label: meses[i - 1],
          });
        }

        return;
      }

      if (esAnual) {
        this.periodos.push({
          value: 1,
          label: 'Anual',
        });
        return;
      }

      if (esBimestral) {
        const { inicio, fin } = obtenerRango(bimestreActual, 6);

        for (let i = inicio; i <= fin; i++) {
          this.periodos.push({ value: i, label: `Bimestre ${i}` });
        }

        return;
      }
    }
  }

  recalcularAnios() {
    const tipo = this.frmCertificadoRetencion.get('tipo_certificado')?.value;
    this.cargarAnios(tipo);
  }

  recalcularPeriodos() {
    const tipo = this.frmCertificadoRetencion.get('tipo_certificado')?.value;
    const anio = this.frmCertificadoRetencion.get('anio')?.value;

    this.actualizarPeriodos(tipo, anio);
  }

  generarCertificado() {
    if (!this.frmCertificadoRetencion.valid) {
      this.frmCertificadoRetencion.markAllAsTouched();
      this.generalMessage = 'FALTAN CAMPOS POR DILIGENCIAR';
      this.haveResponde = true;
      this.haveDataToShow = false;
      return;
    }

    const tipoUI = this.frmCertificadoRetencion.get('tipo_certificado')?.value;
    const anio = this.frmCertificadoRetencion.get('anio')?.value;
    const periodo = this.frmCertificadoRetencion.get('periodo')?.value;

    let tipoBackend = '';
    // let nombreClave = '';
    let params: any = {
      p_documento: this.cedula_Asesor,
      p_anio: anio.toString(),
    };

    switch (tipoUI) {
      case 'RF':
        tipoBackend = 'retefuente';
        // nombreClave = 'getPrReteFte';
        break;

      case 'RI':
        tipoBackend = 'reteica';
        // nombreClave = 'getPrReteIca';
        params.p_periodo = periodo.toString();
        break;

      case 'RV':
        tipoBackend = 'reteiva';
        // nombreClave = 'getPrReteIva';
        params.p_periodo = periodo.toString();
        break;

      default:
        alert('Tipo no válido');
        return;
    }

    const body = {
      // nombreClave,
      jsonParametros: JSON.stringify(params),
    };

    this.certificadosService.descargarCertificado(tipoBackend, body).subscribe({
      next: async (res) => {
        this.spinner.hide();

        // Detectar si la respuesta es JSON (error) en vez de PDF
        if (res.body && res.body.type === 'application/json') {
          try {
            const text = await res.body.text();
            const json = JSON.parse(text);

            this.generalMessage = json.errorMessage || json.message;
            this.haveDataToShow = false;
            this.haveResponde = true;

            return;
          } catch (e) {
            this.generalMessage = 'Error procesando respuesta';
            this.haveDataToShow = false;
            this.haveResponde = true;
            return;
          }
        }

        // Si es PDF
        if (res.body && res.body.size > 0) {
          const blob = res.body;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = url;
          a.download = `certificado_${tipoBackend}_${anio}.pdf`;
          a.click();

          window.URL.revokeObjectURL(url);

          this.haveDataToShow = true;

          this.dialog.open(this.dialogDescargaExitosa, {
            width: '600px',
            maxWidth: '95vw',
          });
        }

        this.haveResponde = true;
      },

      error: async (err) => {
        this.spinner.hide();
        this.haveResponde = true;
        this.haveDataToShow = false;

        if (err.error instanceof Blob) {
          try {
            const text = await err.error.text();
            const json = JSON.parse(text);
            this.generalMessage = json.message;
          } catch (e) {
            this.generalMessage = 'Error generando certificado';
          }
        } else if (err.error?.message) {
          this.generalMessage = err.error.message;
        } else {
          this.generalMessage = 'Error generando certificado';
        }
      },
    });
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }

  cerrarDialogo() {
    this.dialog.closeAll();
  }
}
